(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  ready(function(){
    var galGo=null;
    document.querySelectorAll('.bp-gal').forEach(function(g){
      var track=g.querySelector('.bp-track');if(!track)return;
      var slides=track.querySelectorAll('.bp-slide');
      var dots=g.parentElement.querySelectorAll('.bp-dot');
      var prev=g.querySelector('.bp-prev'),next=g.querySelector('.bp-next');
      function idx(){return Math.round(track.scrollLeft/track.clientWidth)}
      function go(i){if(i<0)i=0;if(i>slides.length-1)i=slides.length-1;track.scrollTo({left:i*track.clientWidth,behavior:'smooth'})}
      if(prev)prev.addEventListener('click',function(){go(idx()-1)});
      if(next)next.addEventListener('click',function(){go(idx()+1)});
      track.addEventListener('scroll',function(){var i=idx();dots.forEach(function(d,n){d.classList.toggle('on',n===i)})},{passive:true});
      if(!galGo){galGo=function(mediaId){if(!mediaId)return;for(var i=0;i<slides.length;i++){if(slides[i].getAttribute('data-media')===String(mediaId)){go(i);return}}}}
    });
    var root=document.getElementById('bp-buy');
    if(root){
      var tiers=root.querySelectorAll('.bp-tier');
      var atc=root.querySelector('.bp-atc');
      var err=root.querySelector('.bp-err');
      var priceEl=root.querySelector('.bp-price');
      var compareEl=root.querySelector('.bp-compare');
      var saveEl=root.querySelector('.bp-save');
      var cur='';
      function money(c){return '$'+(c/100).toFixed(2)}
      function select(t,slide){
        tiers.forEach(function(x){x.classList.remove('on');var i=x.querySelector('input');if(i)i.checked=false});
        t.classList.add('on');var inp=t.querySelector('input');if(inp)inp.checked=true;
        cur=t.getAttribute('data-vid');
        var p=parseInt(t.getAttribute('data-price'),10)||0;
        var c=parseInt(t.getAttribute('data-compare'),10)||0;
        if(priceEl)priceEl.textContent=money(p);
        if(compareEl){if(c>p){compareEl.textContent=money(c);compareEl.style.display='inline'}else{compareEl.style.display='none'}}
        if(saveEl){if(c>p){saveEl.textContent='Save '+money(c-p);saveEl.style.display='inline-block'}else{saveEl.style.display='none'}}
        if(slide&&galGo)galGo(t.getAttribute('data-media'));
      }
      tiers.forEach(function(t){t.addEventListener('click',function(){select(t,true)})});
      var def=root.querySelector('.bp-tier[data-default="1"]')||tiers[0];
      if(def)select(def,false);
      if(atc){atc.addEventListener('click',function(){
        if(!cur)return;
        atc.disabled=true;if(err)err.style.display='none';
        var items=[{id:parseInt(cur,10),quantity:1}];
        root.querySelectorAll('.bp-addon input:checked').forEach(function(a){var v=parseInt(a.getAttribute('data-vid'),10);if(v)items.push({id:v,quantity:1})});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}).then(function(r){if(!r.ok)throw new Error('add failed');return r.json()}).then(function(){window.location.href='/cart'}).catch(function(){atc.disabled=false;if(err){err.textContent='Something went wrong — please try again.';err.style.display='block'}});
      })}
    }
  });
})();